import { BasePreAuthenticationConfig } from '@/services/auth/call-with-auth/base'

export class PreRegisterProvisional extends BasePreAuthenticationConfig {
  readonly id: string = 'register provisional'

  processable(): boolean {
    return !this.authStateStore.hasAccessToken()
  }

  cascade(): boolean {
    return false
  }

  process(): Promise<void> {
    return this.authGateway.registerProvisional().then(result => result.fold(
      this.throwOnFail('fail register provisional'),
      this.onSuccess('success to reload a code')
    ))
  }
}
